/**
 * Resident list columns — config-driven, user-customizable via the "Columns" box.
 * Mirrors the application / reimbursements list column system.
 */

export const RESIDENT_LIST_COLUMN_OPTIONS = [
  { id: 'applicant_id', label: 'Applicant' },
  { id: 'first_name', label: 'Resident Name' },
  { id: 'unit_number', label: 'Unit #' },
  { id: 'company_name', label: 'Company' },
  { id: 'property_name', label: 'Property' },
  { id: 'sales_exec_name', label: 'Sales Exec' },
  { id: 'contract_start_date', label: 'Lease Start Date' },
  { id: 'vintage', label: 'Vintage Year' },
  { id: 'resident_rental_status', label: 'Resident Status' },
  { id: 'resident_rental_progress', label: 'Resident Progress' },
  { id: 'reimbursement_type', label: 'Reimbursement Type' },
  { id: 'reimbursement_rental_status', label: 'Reimbursement Status' },
  { id: 'reimbursement_rental_progress', label: 'Reimbursement Progress' },
  { id: 'select', label: 'Select All' },
  { id: 'pay_status', label: 'Rent Paid Status' },
  { id: 'access_confirmation', label: 'Access Confirmation' },
  
] as const

/** Always rendered; excluded from Customize columns. */
export const RESIDENT_LIST_LOCKED_COLUMN_IDS = ['applicant_id'] as const

export const RESIDENT_LIST_CUSTOMIZABLE_COLUMN_OPTIONS =
  RESIDENT_LIST_COLUMN_OPTIONS.filter((column) => column.id !== 'applicant_id')

export const RESIDENT_LIST_DATA_COLUMN_IDS = RESIDENT_LIST_COLUMN_OPTIONS.map(
  (column) => column.id,
)

export const RESIDENT_COLUMN_VISIBILITY_STORAGE_KEY =
  'resident-list-column-visibility-v4'
